import makeStyles from '@mui/styles/makeStyles';
import { alpha } from '@mui/material';

export const getStyles = (theme) => ({
    actions: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        color: theme.palette.referral.timeline.textPrimary,
        '& .MuiIconButton-root': {
            color: theme.palette.referral.table.textColor,
        },
        '& .MuiSvgIcon-root': {
            fontSize: 16,
        },
    },
    tableWrapper: {
        pl: 0,
        pr: 0,
    },
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: 0,
        padding: 0,
        backgroundColor: theme.palette.background.defaultBackground,
        border: `1px solid ${theme.palette.background.paper}`,
        borderRadius: 2,
    },
    refTableHaeder: {
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1fr) auto',
        alignItems: 'center',
        gap: theme.spacing(2),
        px: 2,
        py: 0.5,
        borderBottom: '1px solid',
        borderColor: theme.palette.divider,
        minHeight: 40,
    },
    headLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        minWidth: 0,
    },
    headRight: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: 1,
        '& .MuiIconButton-root': {
            color: theme.palette.referral.table.textColor,
        },
    },
    select: {
        minWidth: 140,
    },
    priorityCell: {
        common: {
            minWidth: 40,
            height: 26,
            px: 1.5,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '10px',
            fontWeight: 600,
            fontSize: '12px',
            lineHeight: 1,
            letterSpacing: '0.1px',
            '& .MuiTypography-root': {
                fontSize: '12px',
                fontWeight: 600,
                lineHeight: 1,
                color: 'inherit',
            },
        },
        small: {
            height: 21,
            fontSize: '10px',
            borderRadius: '6px',
            fontWeight: 600,
            '& .MuiTypography-root': {
                fontSize: '10px',
                fontWeight: 600,
                lineHeight: 1,
                color: 'inherit',
            },
        },
        urgent: {
            color: theme.palette.referral.colorAcknowledged,
            border: `1px solid ${theme.palette.referral.colorAcknowledged}`,
        },
        emergency: {
            color: theme.palette.referral.colorRequested,
            border: `1px solid ${theme.palette.referral.colorRequested}`,
        },
        routine: {
            color: theme.palette.default.main,
            border: `1px solid ${theme.palette.default.main}`,
        },
        outcome: {
            color: theme.palette.referral.colorCompleted,
            backgroundColor: alpha(theme.palette.referral.colorCompleted, 0.15),
            border: `1px solid ${theme.palette.referral.colorCompleted}`,
        },
    },
    statusCell: {
        common: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 1,
            minHeight: 24,
            fontSize: 'small',
            fontWeight: 500,
            lineHeight: 1,
            '& .MuiTypography-root': {
                fontSize: 'small',
                fontWeight: 500,
                lineHeight: 1,
                color: 'inherit',
            },
        },
        dot: {
            width: 10,
            height: 10,
            minWidth: 10,
            borderRadius: '50%',
            backgroundColor: 'currentColor',
        },
        requested: {
            color: theme.palette.referral.colorRequested,
        },
        assessed: {
            color: theme.palette.referral.colorAssessed,
        },
        completed: {
            color: theme.palette.referral.colorCompleted,
        },
        acknowledged: {
            color: theme.palette.referral.colorAcknowledged,
        },
    },
});

export const useAddRefDialog = makeStyles((theme) => ({
    backgroundOverride: {
        backgroundColor: `${theme.palette.inPatient.formBackground} !important`,
    },
    actionNoDivider: {
        borderBottom: 'none',
    },
    maxHeight: {
        maxHeight: 'calc(100vh - 400px)',
    },
    title: {
        fontSize: 16,
    },
}));

export const useStylesAgyleTable = makeStyles((theme) => ({
    headerRow: {
        '& > th:first-of-type, & > .MuiTableCell-head:first-of-type': {
            paddingLeft: 8,
        },
        '& > th:last-of-type, & > .MuiTableCell-head:last-of-type': {
            paddingRight: 8,
        },
    },
    blueTextCell: {
        color: `${theme.palette.referral.main} !important`,
    },
    headerRowCell: {
        //border: "8px solid black",
        //borderRadius: "4px",
        background: theme.palette.referral.timeline.background,
        color: theme.palette.referral.main,
        height: '48px',
        '& .MuiIconButton-root': {
            color: `${theme.palette.referral.table.textColor} !important`,
        },
    },
    tableContainer: {
        paddingTop: 0,
        '& .MuiTable-root': {
            borderSpacing: 0,
            borderCollapse: 'separate',
        },
    },
    tableRow: {
        fontSize: 'small',
        height: '48px',
        '& > .MuiTableCell-root': {
            borderBottom: '1px solid ' + theme.palette.referral.table.background,
            paddingBottom: '8px !important',
            paddingTop: '8px !important',
            color: theme.palette.referral.table.textColor,
        },
        '&:last-child > .MuiTableCell-root': {
            borderBottom: '0px',
            paddingBottom: '8px !important',
        },
        '&:hover': {
            background: theme.palette.referral.table.hover,
        },
        '& > .MuiTableCell-root:first-child': {
            paddingLeft: 8,
        },
    },
}));

export const getStylesAddDialog = (theme) => ({
    sectionTitle: {
        mb: 3,
        color: theme.palette.default.main,
        fontSize: '13px',
        fontWeight: 700,
    },

    optionalSectionTitle: {
        mt: 1,
        mb: 2,
        color: theme.palette.default.main,
        fontSize: '13px',
        fontWeight: 700,
        letterSpacing: '0.08em',
    },

    label: {
        mb: 1,
        fontSize: '14px',
        fontWeight: 600,
    },

    actions: {
        mt: 4,
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 1.5,
    },
});

export const getStylesTimelineSetpIcon = (theme, highlighted, step) => {
    return {
        width: 24,
        height: 24,
        borderRadius: '50%',
        display: 'grid',
        placeItems: 'center',
        bgcolor: highlighted ? theme.palette.referral[`color${step.key}`] : theme.palette.referral.timeline.textSecondary,
        color: highlighted ? '#fff' : theme.palette.referral.timeline.stepIcon,
        border: '1px solid',
        borderColor: highlighted
            ? alpha(theme.palette.referral[`color${step.key}`], 0.38)
            : theme.palette.referral.timeline.cardBorderColor,
        //boxShadow: active ? `0 0 0 6px ${theme.palette.referral.timeline.stepActiveBorderColor}` : 'none',
        transition: 'all .2s ease',
    };
};

export const getStylesHistoryIcon = (theme, isStatusChange, status) => {
    const accent = isStatusChange ? theme.palette.referral[`color${status}`] : theme.palette.referral.timeline.cardBorderColor;
    return {
        box1: {
            width: 18,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            flexShrink: 0,
        },
        box2: {
            width: 18,
            height: 18,
            borderRadius: '50%',
            bgcolor: accent,
            color: '#fff',
            display: 'grid',
            placeItems: 'center',
            boxShadow: `0 0 0 3px ${theme.palette.referral.timeline.shadowColor}`,
        },
        box3: {
            mt: 0.75,
            width: '1px',
            flex: 1,
            minHeight: 56,
            bgcolor: theme.palette.referral.timeline.cardBorderColor,
        },
        card: {
            flex: 1,
            p: 2,
            borderRadius: 2,
            bgcolor: theme.palette.referral.timeline.bulletBackground,
            border: theme.palette.referral.timeline.cardBorder,
        },
        status: {
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: 0.35,
            color: theme.palette.referral.main,
            mb: 0.75,
        },
        note: {
            fontSize: 15,
            color: theme.palette.referral.timeline.textPrimary,
            mb: 1.25,
            whiteSpace: 'pre-line',
        },
        summary: {
            time: { fontSize: 12, color: theme.palette.referral.timeline.textSecondary },
            userIcon: { fontSize: 14, color: theme.palette.referral.timeline.textSecondary },
            user: { fontSize: 12, color: theme.palette.referral.main },
        },
    };
};

export const getStylesTimeline = (theme) => ({
    background: {
        //minHeight: '100vh',
        bgcolor: theme.palette.referral.timeline.background,
        color: '#fff',
        px: { xs: 2, md: 3 },
        py: 2,
    },
    card: {
        bgcolor: theme.palette.referral.timeline.cardBackground,
        border: theme.palette.referral.timeline.cardBorder,
        borderRadius: 2,
        overflow: 'hidden',
    },
    headerButtonsBackground: {
        px: { xs: 2, md: 3 },
        py: 1.5,
        borderBottom: theme.palette.referral.timeline.cardBorder,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        flexWrap: 'wrap',
    },
    backIcon: {
        color: theme.palette.referral.timeline.textSecondary,
        border: theme.palette.referral.timeline.cardBorder,
    },
    deleteIcon: {
        color: theme.palette.referral.timeline.textSecondary,
        border: theme.palette.referral.timeline.cardBorder,
        borderRadius: 2,
    },
    headBackground: {
        px: { xs: 2, md: 3 },
        py: 1.75,
        borderBottom: theme.palette.referral.timeline.cardBorder,
    },
    headText: { fontSize: 14, fontWeight: 600, color: theme.palette.referral.timeline.textPrimary },
    headIcon: { fontSize: 16, color: theme.palette.referral.timeline.textSecondary },
    headSpecialty: { fontSize: 14, fontWeight: 600, color: theme.palette.referral.main },
    stepBackground: {
        px: { xs: 2, md: 3 },
        py: 3,
        borderBottom: theme.palette.referral.timeline.cardBorder,
        overflowX: 'auto',
    },
    stepConnector: {
        flex: 1,
        mx: 2,
        top: 0,
        minWidth: 40,

        '& .MuiStepConnector-line': {
            position: 'relative',
            display: 'block',
            width: '100%',
            height: 0,
            border: 0,
            borderTop: theme.palette.referral.timeline.stepConnectorBorder,
        },

        '& .MuiStepConnector-line::after': {
            content: '""',
            position: 'absolute',
            right: -1,
            top: '50%',
            width: 8,
            height: 8,
            borderTop: theme.palette.referral.timeline.stepConnectorArrow,
            borderRight: theme.palette.referral.timeline.stepConnectorArrow,
            transform: 'translateY(-50%) rotate(45deg)',
        },
    },
    stepper: {
        width: '100%',
        px: 1,
        '& .MuiStep-root': {
            p: 0,
            minWidth: 0,
        },
        '& .MuiStepLabel-root': {
            display: 'none',
        },
        '& .MuiStepConnector-root': {
            flex: 1,
            minWidth: 40,
            display: 'flex',
            alignItems: 'center',
            mx: 2,
        },
    },
    reasonBackground: {
        px: { xs: 2, md: 3 },
        py: 2.5,
        borderBottom: theme.palette.referral.timeline.cardBorder,
    },
    reasonText: { fontSize: 13, fontWeight: 700, letterSpacing: 0.6, color: theme.palette.referral.main, mb: 1 },
    reason: { fontSize: 13, color: theme.palette.referral.timeline.textPrimary },
    historyBackground: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mb: 2,
        gap: 2,
        flexWrap: 'wrap',
    },
    historyLabel: {
        fontSize: 13,
        fontWeight: 700,
        letterSpacing: 0.6,
        color: theme.palette.referral.main,
    },
    addNoteButton: {
        textTransform: 'none',
        color: theme.palette.referral.main,
        fontWeight: 600,
        minWidth: 'auto',
        p: 0,
        '&:hover': {
            bgcolor: 'transparent',
            opacity: 0.85,
        },
    },
    addNoteBackground: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        mb: 2,
        p: 2,
        bgcolor: theme.palette.referral.timeline.bulletBackground,
        border: theme.palette.referral.timeline.cardBorder,
        borderRadius: 2,
    },
    addNoteFoot: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 2,
        flexWrap: 'wrap',
    },
});

export const getStylesStep = (theme, isActive, completed, canClick, step) => {
    return {
        root: {
            flex: '0 0 auto',
            minWidth: 0,
        },
        button: {
            width: 'fit-content',
            maxWidth: '100%',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            gap: 1.25,
            px: 1.75,
            py: 1.25,
            borderRadius: 2,
            border: '1px solid',
            textAlign: 'left',
            minHeight: 64,
            bgcolor: isActive ? alpha(theme.palette.referral[`color${step}`], 0.08) : theme.palette.referral.timeline.bulletBackground,
            borderColor: completed ? alpha(theme.palette.referral[`color${step}`], 0.35) : theme.palette.referral.timeline.cardBorderColor,
            boxShadow: isActive
                ? `0 0 0 1px ${alpha(theme.palette.referral[`color${step}`], 0.08)}, 0 0 24px ${alpha(theme.palette.referral[`color${step}`], 0.12)}`
                : 'none',
            opacity: canClick ? 1 : 0.7,
            '&.Mui-disabled': {
                opacity: 1,
                cursor: 'not-allowed',
            },
            '&:hover': {
                bgcolor: isActive
                    ? alpha(theme.palette.referral[`color${step}`], 0.12)
                    : alpha(theme.palette.referral.timeline.bulletBackground, 0.7),
            },
        },
        icon: { flexShrink: 0, display: 'flex', alignItems: 'center' },
        label: {
            fontSize: 13,
            fontWeight: 700,
            letterSpacing: 0.4,
            color: completed ? theme.palette.referral[`color${step}`] : theme.palette.referral.timeline.textPrimary,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        dateLabel: {
            mt: 0.25,
            fontSize: 12,
            color: theme.palette.referral.timeline.textSecondary,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        outcome: {
            bgcolor: theme.palette.referral.colorCompleted,
            color: theme.palette.referral.contrastText,
        },
    };
};
